import {Injectable, OnDestroy} from '@angular/core';
import {BaseDao} from '../../base-dao';
import {KluhManagerValidator} from '../../validators/kluh-manager-validator';
import {Observable, Subject} from 'rxjs';
import {ClientSettings} from '../../models';
import {shareReplay, takeUntil} from 'rxjs/operators';
import {CacheControl} from '../../helpers/CacheControl';
import {R2CloudHttpApiService} from '../../r2-cloud-http-api.service';

@Injectable()
export class ClientSettingsDaoService extends BaseDao<ClientSettings> implements OnDestroy, CacheControl {
    private myClientSettings$: Observable<ClientSettings>;
    private onDestroy$ = new Subject();

    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'client-settings');
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    setCacheControl(ob: Observable<any>): void {
        ob.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.clearCache();
        });
    }

    clearCache(): void {
        this.myClientSettings$ = null;
    }

    getMyClientSettings(): Observable<ClientSettings> {
        if (!this.myClientSettings$) {
            this.myClientSettings$ = this.http.get<ClientSettings>(this.url + '/me').pipe(shareReplay(1));
        }
        return this.myClientSettings$;
    }

    saveMyClientSettings(clientSettings: ClientSettings): Observable<ClientSettings> {
        return this.http.put<ClientSettings>(this.url + '/me', clientSettings);
    }
}
